import {memo} from "react";
import {Chip} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";

interface TransactionLabelProps {
    status: string
}

const TransactionLabel = ({status}: TransactionLabelProps) => {
    const {t} = useTranslation();
    const color = ['Successful', 'Accepted', 'Approved'].includes(status) ? 'teal' : (['failed', 'Rejected', 'Declined'].includes(status) ? 'red' : (status === 'Outdated' ? 'gray' : 'cyan'))
    const variant = status === 'Outdated' ? 'ghost' : 'gradient';

    return <Chip className="w-fit inline-block dark:text-white" variant={variant}
                 value={t('admin.transaction.status.' + status.toLowerCase())} color={color}/>;
}

export default memo(TransactionLabel);
